/**
 * MuiAvatar
 */
const MuiAvatar = {
  styleOverrides: {
    colorDefault: ({
      theme
    }) => ({
      backgroundColor: theme.palette.primary.main
    })
  }
};
export default MuiAvatar;